export const calculateFontSize = (currentHeight, maxFontSize, minFontSize, maxHeight, minHeight) => {
    const ratio = (currentHeight - minHeight) / (maxHeight - minHeight);
    return minFontSize + (maxFontSize - minFontSize) * ratio;
};